<template>
  <v-form ref="supplierForm" v-model="valid" :lazy-validation="lazy">
    <v-row dense>
      <v-col cols="12" xs="12" md="3">
        <v-text-field type="text" autocomplete="off" outlined dense label="Supplier Name" v-model="record.Name"
          :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field type="text" autocomplete="off" outlined dense label="Phone" v-model="record.PhoneNumber"
          :rules="inputRules"></v-text-field>
      </v-col>

      <v-col cols="12" xs="12" md="3">
        <v-text-field type="text" autocomplete="off" outlined dense label="Email" v-model="record.Email"></v-text-field>
      </v-col>

      <!-- <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" hide-details dense outlined v-model="record.storeId" :items="stores"
          label="Store / Shop" item-text="Name" item-value="id"></v-autocomplete>
      </v-col> -->

      <v-col cols="12" md="3">
        <v-autocomplete autocomplete="off" hide-details dense outlined v-model="record.paymentTerm" :items="termsData"
          label="Payment Terms" item-text="PymntGroup" item-value="id"></v-autocomplete>
      </v-col>

      <v-col cols="12" md="6">
        <v-text-field type="text" autocomplete="off" outlined dense label="Pin No"
          v-model="record.PinNo"></v-text-field>
      </v-col>

      <v-col cols="12">
        <v-btn v-if="docCreate == true" color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Save
        </v-btn>

        <v-btn v-else color="primary" @click="sendData" :loading="$store.state.btnLoader">
          <v-icon left>mdi-content-save</v-icon>Update
        </v-btn>
      </v-col>
    </v-row>

    <snackbar ref="snackbar"></snackbar>
  </v-form>
</template>


<script>
export default {
  props: {
    initial: {
      type: Object,
      required: true
    },
    docCreate: {
      type: Boolean
    }
  },
  data: () => ({
    valid: false,
    lazy: false,
    inputRules: [v => !!v || "Required"],
    record: {},
    termsData: [],
    stores: [],
    loader: false,
    date: new Date().toISOString().substr(0, 10)
  }),
  watch: {
    initial: {
      handler: "init",
      immediate: true
    }
  },
  computed: {
    activeStore() {
      return localStorage.getItem("store_id");
    },
  },
  methods: {
    init(val) {
      this.record = { ...val };
    },
    setDate(date) {
      this.record.date = date;
    },
    sendData() {
      if (!this.$refs.supplierForm.validate()) {
        this.$refs.snackbar.show("Please fill all the fields", "red");
        return;
      }

      var storeId = parseInt(this.activeStore);
      this.record.store_id = storeId;
      this.$store.commit("btnLoader", true);
      this.$emit("data", this.record);
    },
    getPaymentTerms() {
      const self = this;
      this.$store
        .dispatch("get", `/payment-terms`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.termsData = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getStores() {
      var userId = localStorage.getItem("userId");
      const self = this;
      this.$store
        .dispatch("get", `/user-stores/${userId}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
    this.getStores();
    //  this.getPaymentTerms();
  }
};
</script>